<ion-header *ngIf="!IsCropped">
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-button (click)="onCancel()"
        ><ion-icon name="arrow-back-outline" slot="icon-only"></ion-icon
      ></ion-button>
    </ion-buttons>
    <ion-title>Edit Image</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="onSaveCrop()"
        ><ion-icon name="arrow-forward-outline" slot="icon-only"></ion-icon
      ></ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-header *ngIf="IsCropped">
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-button (click)="BackToCrop()"
        ><ion-icon name="arrow-back-outline" slot="icon-only"></ion-icon
      ></ion-button>
    </ion-buttons>
    <ion-title>Upload Image</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="UploadImage()"
        ><ion-icon name="checkmark-outline" slot="icon-only"></ion-icon
      ></ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content color="lightmimbo">
  <div *ngIf="!IsCropped" style="padding: 20px">
    <angular-cropper
      #angularCropper
      [cropperOptions]="cropperOptions"
      [imageUrl]="uploadedImage"
      *ngIf="show"
    ></angular-cropper>
  </div>
  <div *ngIf="croppedImage && IsCropped">
    <ion-card class="post">
      <ion-card-content
        class="ion-no-padding"
        [ngClass]="{ 'no-line-height': hideCaption }"
      >
        <img [src]="croppedImage" style="width: 100%" />
        <ion-textarea
          *ngIf="!hideCaption"
          class="italic textarea-padding"
          rows="2"
          autoGrow="true"
          maxlength="250"
          placeholder="Write a caption..."
          [(ngModel)]="Caption"
        ></ion-textarea>
      </ion-card-content>
    </ion-card>
  </div>
</ion-content>

<ion-footer *ngIf="!IsCropped">
  <ion-toolbar color="primary">
    <div class="center-buttons">
      <ion-buttons slot="primary">
        <ion-button (click)="zoom(true)" size="small">
          <ion-icon
            src="../../../assets/images/icons/zoomIn.svg"
            slot="icon-only"
          ></ion-icon>
        </ion-button>
        <ion-button (click)="zoom(false)" size="small">
          <ion-icon
            src="../../../assets/images/icons/zoomOut.svg"
            slot="icon-only"
          ></ion-icon>
        </ion-button>
        <ion-col>
          <ion-button size="small" (click)="rotate()">
            <ion-icon
              src="../../../assets/images/icons/rotate.svg"
              slot="icon-only"
            ></ion-icon>
          </ion-button>
        </ion-col>

        <ion-col>
          <ion-button size="small" (click)="scaleX()">
            <ion-icon
              src="../../../assets/images/icons/flipX.svg"
              slot="icon-only"
            ></ion-icon>
          </ion-button>
        </ion-col>
        <ion-col>
          <ion-button size="small" (click)="scaleY()">
            <ion-icon
              src="../../../assets/images/icons/flipY.svg"
              slot="icon-only"
            ></ion-icon>
          </ion-button>
        </ion-col>
      </ion-buttons>
    </div>
  </ion-toolbar>
</ion-footer>
